// extracted by mini-css-extract-plugin
module.exports = {"container":"AppsAndGamesList_container__6I6kK","item":"AppsAndGamesList_item__QvsI7","link":"AppsAndGamesList_link__7qyf9"};